import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import Image from "next/image";
import { DetailedHTMLProps, HTMLAttributes, useMemo } from "react";

export const Tilerail = ({
    style,
    height,
    items,
    direction,
    duration,
    edge,
    gap,
    className,
    ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    items: string[];
    height: number;
    edge: number;
    duration: number;
    direction: 1 | -1;
    gap: number;
}) => {
    const validItems = useMemo(() => items, [items]);
    const groupHeight = validItems.length * (edge + gap);

    return (
        <div
            className={cn(
                "relative flex h-full flex-col overflow-hidden",
                className
            )}
            style={{ ...style, width: edge }}
            {...props}
        >
            <motion.div
                className="flex w-full flex-col"
                initial={{ y: direction === 1 ? -groupHeight : 0 }}
                animate={{ y: direction === 1 ? 0 : -groupHeight }}
                transition={{
                    duration,
                    ease: "linear",
                    repeat: Infinity
                }}
            >
                {validItems.map((imgurl, index) => (
                    <div
                        key={index}
                        className="relative flex select-none items-center
                            justify-center overflow-hidden rounded-[20px]
                            bg-white lg:rounded-xl"
                        style={{ width: edge, height: edge, marginBottom: gap }}
                    >
                        <Image
                            alt="source"
                            src={imgurl}
                            fill={true}
                            style={{ objectFit: "cover" }}
                            sizes="(max-width: 768px) 56px, (max-width: 1024px) 64px, 80px"
                        />
                    </div>
                ))}
            </motion.div>
            <motion.div
                className="flex w-full flex-col"
                initial={{ y: direction === 1 ? -groupHeight : 0 }}
                animate={{ y: direction === 1 ? 0 : -groupHeight }}
                transition={{
                    duration,
                    ease: "linear",
                    repeat: Infinity
                }}
            >
                {validItems.map((imgurl, index) => (
                    <div
                        key={index}
                        className="relative flex select-none items-center
                            justify-center overflow-hidden rounded-[20px]
                            bg-white lg:rounded-xl"
                        style={{ width: edge, height: edge, marginBottom: gap }}
                    >
                        <Image
                            alt="source"
                            src={imgurl}
                            fill={true}
                            style={{ objectFit: "cover" }}
                            sizes="(max-width: 768px) 56px, (max-width: 1024px) 64px, 80px"
                        />
                    </div>
                ))}
            </motion.div>
        </div>
    );
};
